import React from 'react';

import AppleCalendarButton from "../AppleCalendarButton/AppleCalendarButton";
import GoogleCalendarButton from "../GoogleCalendarButton/GoogleCalendarButton";

import style from './AddToCalendarButtons.module.scss';
import useAuth from '../../hooks/useAuth';

const AddToCalendarButtons = ({className = '', buttonsClassName = ''}) => {
    const {user} = useAuth();

    if (!user) {
        return;
    }
    
    return (
        <div className={`${style.wrapper} ${className}`}>
            <GoogleCalendarButton className={buttonsClassName} />
            <AppleCalendarButton className={buttonsClassName} />
        </div>
    )
}

export default AddToCalendarButtons;